import {useEffect} from 'react';
import setGlobalState from '../redux/setGlobalState';

const KEYBOARD_HEIGHT_THRESHOLD = 150;

function updateKeyboardOpenState() {
    const viewport = window.visualViewport;
    if(!viewport) {
        return;
    }
    const keyboardOpen = window.innerHeight - viewport.height > KEYBOARD_HEIGHT_THRESHOLD;
    setGlobalState('ui.isKeyboardOpen', keyboardOpen);
}

function useWindowWidth() {

    useEffect(() => {
        function handleResize() {
            setGlobalState('ui.windowWidth', Number(window.innerWidth));
            updateKeyboardOpenState();
        }

        window.addEventListener('resize', handleResize);
        window.visualViewport?.addEventListener('resize', updateKeyboardOpenState);
        window.visualViewport?.addEventListener('scroll', updateKeyboardOpenState);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.visualViewport?.removeEventListener('resize', updateKeyboardOpenState);
            window.visualViewport?.removeEventListener('scroll', updateKeyboardOpenState);
        };
    }, []);

}

export default useWindowWidth;
